import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {ForYouSubSection} from './shared/ForYouSubSection'
import {ChangesRequested} from './mergeability/ChangesRequested'
import {RequiredReviewer} from './mergeability/RequiredReviewer'
import {PendingChecks} from './mergeability/PendingChecks'
import {MergeConflicts} from './mergeability/MergeConflicts'
import {FailingChecks} from './mergeability/FailingChecks'
import {CompletedChecks} from './mergeability/CompletedChecks'
import {Findings} from './findings/Findings'
import {UnresolvedComments} from './commenting/UnresolvedComments'
import {Deployments} from './deployments/Deployments'
import {ResolvedComments} from './commenting/ResolvedComments'
import {MentionedComments} from './commenting/MentionedComments'
import {ReviewRequested} from './review/ReviewRequested'
import {ReviewPending} from './review/ReviewPending'
import {ChangesSinceLastReview} from './review/ChangesSinceLastReview'
import {Approved} from './mergeability/Approved'
import {CommentReview} from './mergeability/CommentReview'
import {ForYouSectionError, ForYouSectionSkeleton} from './ForYouSectionFallbacks'

export function ForYouSection() {
  return (
    <ErrorBoundary boundaryName="ForYouSection" fallback={<ForYouSectionError />}>
      <Suspense fallback={<ForYouSectionSkeleton />}>
        <ForYouSectionContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function ForYouSectionContent() {
  return (
    <div className="d-flex gap-3 flex-column">
      <NeedsAttentionSection />
      <RelevantToYouSection />
      <CompletedSection />
    </div>
  )
}

function NeedsAttentionSection() {
  return (
    <ForYouSubSection title="Needs Attention">
      <MergeConflicts />
      <ChangesRequested />
      <FailingChecks />
      <Findings />
      <UnresolvedComments />
      <MentionedComments />
      <ReviewRequested />
      <ReviewPending />
      <ChangesSinceLastReview />
    </ForYouSubSection>
  )
}

function RelevantToYouSection() {
  return (
    <ForYouSubSection title="Relevant to You">
      <Approved />
      <CommentReview />
      <PendingChecks />
      <Deployments />
      <RequiredReviewer />
    </ForYouSubSection>
  )
}

function CompletedSection() {
  return (
    <ForYouSubSection title="Completed">
      <CompletedChecks />
      <ResolvedComments />
    </ForYouSubSection>
  )
}
